import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Input,
    OnInit,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: '[cookieboxContent]',
    template: '',
    styleUrl: './cookiebox-content-container.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[innerHTML]': 'cookieboxContent',
    },
})
export class CookieboxContentContainerComponent implements OnInit {
    @Input()
    public cookieboxContent: SafeHtml = '';

    private elementRef: ElementRef<HTMLElement> = inject(ElementRef);
    private renderer = inject(Renderer2);

    public ngOnInit(): void {
        this.renderer.addClass(this.elementRef.nativeElement, 'cookiebox-content');
    }
}
